import { render, staticRenderFns } from "./WBtnPrevious.vue?vue&type=template&id=ee402c08&scoped=true&"
import script from "./WBtnPrevious.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnPrevious.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee402c08",
  null
  
)

export default component.exports